import { userProfiles } from './user-profiles.i18n';

export const en = {
  userProfiles
};
